import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LessonPreviewComponent } from './lesson-preview/lesson-preview.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { QuestionnaireElementModule } from '../questionnaire-element/questionnaire-element.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MaterialModule } from '../material/material.module';
import { SkillPreviewComponent } from './skill-preview/skill-preview.component';
import { QuestionnairePreviewComponent } from './questionnaire-preview/questionnaire-preview.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export const createTranslateLoader = (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json');

@NgModule({
  declarations: [LessonPreviewComponent, SkillPreviewComponent, QuestionnairePreviewComponent],
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    QuestionnaireElementModule,
    FontAwesomeModule,
    MaterialModule
  ],
  exports: [LessonPreviewComponent, SkillPreviewComponent, QuestionnairePreviewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class QuestionnaireModule {}
